<template lang="html">
  <root class="admin-country-delete">

    <admin-nav></admin-nav>
    <page-header name="Delete country" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
            <p>Are you sure to delete the country <strong v-if="country.name">{{ country.name.en }}</strong> ?</p>
        </div>
      </div>

      <div class="row">
        <div class="col m3 offset-m3">
          <router-link :to="{ name: 'Countries' }" class="waves-effect waves-light btn">No</router-link>
        </div>
        <div class="col m3">
          <a class="waves-effect waves-dark btn-flat" @click="checkPermission">Yes</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from 'firebase'
import _ from 'lodash'

export default {
  data() {
    return {
      countryKey: this.$route.params.countryKey,
      country: {}
    }
  },

  methods: {
    collect() {
      firebase.database()
        .ref('countries/' + this.countryKey)
        .once('value')
        .then( countrySnap => {
          this.country = countrySnap.val()
        })
    },

    checkPermission() {

      // Check any user found on that country
      firebase.database()
        .ref('users')
        .once('value')
        .then( usersSnap => {

          // No users
          if (!usersSnap.numChildren()) {
            this.remove()
            return false
          }
          
          let users = usersSnap.val()

          _.forEach(users, user => {
            if (user.country == this.countryKey) {
              this.cantDelete()
              return false
            }

            // Check any business found on that country
            let businesses = user.business

            if (businesses) {
              _.forEach(businesses, business => {
                if (business.country == this.countryKey) {
                  this.cantDelete()
                  return false
                }
              })
            }

            this.remove()
            return false
          })

        })
    },

    cantDelete() {
      Materialize.toast('Can\'t delete. Data exist', 4000)
      this.$router.push({ name: 'Countries' })
    },

    remove() {
      firebase.database()
        .ref('countries/' + this.countryKey)
        .remove()
        .then( () => {
          Materialize.toast('Deleted', 4000)
          this.$router.push({ name: 'Countries' })
        })
    }
  },

  mounted() {
    this.collect()
  }
}
</script>

<style lang="scss">
.admin-country-delete {
  p {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/CountryDelete.vue